import React from 'react';

import PropertyRelationsForm from '~/components/Common/Forms/PropertyRelationsForm';

export default function PropertyRelationsContainer() {
  return <PropertyRelationsForm />;
}
